<div class="spinner-border text-primary" role="status">
  <span class="visually-hidden">Cargado...</span>
</div>
<br />
<br />
<strong>{{ message }}...</strong>
